export enum UpdateTermsAndPrivacyName {
    TERMS = "termsAndConditions",
    PERSONAL_DATA_TREATMENT = "personalDataTreatmentAuthorization",
    PRIVACY = "privacyPolicy",
}

export enum ViewTermsAndPrivacyType {
    TERMS = "tyc",
    PERSONAL_DATA_TREATMENT = "personalDataTreatment",
    PRIVACY = "policy",
}

export interface UpdateTermsAndPrivacyState {
    [UpdateTermsAndPrivacyName.TERMS]?: File | null;
    [UpdateTermsAndPrivacyName.PERSONAL_DATA_TREATMENT]?: File | null;
    [UpdateTermsAndPrivacyName.PRIVACY]?: File | null;
}
